module.exports = __webpack_public_path__ + "img/Cara_Naranja.d5c1a0ef.svg";